// Categories from API
export enum Categories {
    Arcade = 'Arcade',
    Strategy = 'Strategy',
    Daily = 'Daily',
    Card = 'Card',
    Solitaire = 'Solitaire',
    Puzzles = 'Puzzles',
    Word = 'Word',
    Members = 'Members',
    Mahjongg = 'Mahjongg',
    New = 'New',
    Rewards = 'AARP Rewards',
    Atari = 'Atari',
    Juegos = 'Juegos', // Category doesn't exist in admin site yet
    Retro = 'Retro',
    StayingSharp = 'Staying Sharp' // Category doesn't exist in admin site yet
}

export enum Pages {
    Home = 'Home',
    All = 'All',
    RecentlyPlayed = 'RecentlyPlayed',
    Help = 'Help',
}
